import TooltipBadge from 'components/TooltipBadge/TooltipBadge'
import { Fragment } from 'react'
import s from './Label.module.scss'

interface Props {
  label: string
  tooltip?: JSX.Element
  classes?: string
}

const defaultProps = {
  tooltip: undefined,
  classes: s.labelTooltip,
}

const Label = ({ label, tooltip, classes }: Props): JSX.Element => (
  <span className={classes}>
    {label.split('<br />').map((str, idx) =>
      idx === 0 ? (
        str
      ) : (
        <Fragment key={idx}>
          <br />
          {str}
        </Fragment>
      )
    )}
    {tooltip && <TooltipBadge label={label} tooltip={tooltip} />}
  </span>
)

Label.defaultProps = defaultProps
export default Label
